export const steps = [
    {
        key: "account",
        title: "Account Information",
        description: "Details about the main account",
    },
    {
        key: "business",
        title: "Business Information",
        description: "Details about your business",
    },
    {
        key: "review",
        title: "Review Information",
        description: "Review your information before submitting",
    },
];

export const companyRoles = [
    "Owner",
    "Chief Executive Officer (CEO)",
    "Chief Financial Officer (CFO)",
    "Chief Operating Officer (COO)",
    "Manager",
    "Employee",
];

export const businessStructures = [
    "Sole Proprietorship",
    "Corporation",
    "Limited Liability Company (LLC)",
    "Partnership",
    "Non-profit Organization",
];